/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { PartsAgreementRestResponse } from '../../models/parts-agreement-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface RetrievePartsAgreements$Params {}

export function retrievePartsAgreements(
  http: HttpClient,
  rootUrl: string,
  params?: RetrievePartsAgreements$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<PartsAgreementRestResponse>>> {
  const rb = new RequestBuilder(rootUrl, retrievePartsAgreements.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PartsAgreementRestResponse>>;
    }),
  );
}

retrievePartsAgreements.PATH = '/parts-agreement';
